import { transition } from '@pixelunion/animations';
import * as breakpoint from '@pixelunion/breakpoint';
import throttle from '../utils/throttle';

export default class BackToTop {
  constructor(el) {
    this.el = el;
    this.button = this.el.querySelector('[data-back-to-top-button]');

    this.animation = transition({ el });

    const pageScrollThreshold = 0.3;

    window.addEventListener('scroll', throttle(() => {
      if (breakpoint.max('M')) return;

      if (this.pageCurrentScrollRatio >= pageScrollThreshold) {
        this.displayButton();
      } else {
        this.hideButton();
      }
    }, 100));
  }

  get pageCurrentScrollRatio() {
    return window.scrollY / (document.body.offsetHeight - window.innerHeight);
  }

  displayButton() {
    this.button.setAttribute('aria-hidden', 'false');
    this.animation.animateTo('visible');
  }

  hideButton() {
    this.button.setAttribute('aria-hidden', 'true');
    this.animation.animateTo('hidden');
  }
}
